import React, { useContext } from 'react'; // Colocar useState u_u
import './Footer.scss';
import { GlobalContext } from 'globalContext';

export default function Footer() {
    const [global] = useContext(GlobalContext); // colocar setGlobal again :)
    // const [open, setOpen] = useState(false); // descomentar '-'

    return (
        <div id="restaurante-footer">
            <footer className="footer d-print-none fixed-bottom">
                <p>Último acesso em: {global.userRest.ult_acesso}</p>
            </footer>
        </div>
    );
}
